import type { FC, ReactNode } from 'react'
import styled from '@emotion/styled'

import type { Document as RichTextDocument } from '@contentful/rich-text-types'

import Divider from '@segment/matcha/components/Divider'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import RichText from '@segment/matcha/recipes/RichText'

interface MainSectionProps {
  heading: string
  description: RichTextDocument
  image: ReactNode
}
const MainSection: FC<MainSectionProps> = ({ heading, description, image }) => {
  return (
    <SectionBaseWrapper variant="noCopy">
      <Section.Contents>
        <StyledSectionBase variant="2Col" reverse={true}>
          <StyledSectionCopy>
            <CopyTextBase>
              <CopyText.Heading>{heading}</CopyText.Heading>
              <CopyText.Description>
                <RichText data={description} />
              </CopyText.Description>
            </CopyTextBase>
          </StyledSectionCopy>
          <Section.Contents>{image}</Section.Contents>
        </StyledSectionBase>
        <Divider />
      </Section.Contents>
    </SectionBaseWrapper>
  )
}

export default MainSection

const SectionBaseWrapper = styled(SectionBase)`
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
`

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 0;
    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding-top: 120px;
      padding-bottom: 120px;
    }
    ${({ theme }) => theme.breakpoints.down(`xs`)} {
      padding: 0 0 40px;
      grid-template-areas:
        'contents'
        'copy';
    }
  }
`

const StyledSectionCopy = styled(Section.Copy)`
  align-self: center;
`
